export default __webpack_public_path__ + "static/media/prize_geprek_nasi_wangi_sambal_ori.8f78648b.png";